<template>
      <div class="sidebar-con" >
        <el-menu
          :default-active="activeMenu"
          text-color="#333333"
          active-text-color="#ec664e"
          :unique-opened="true"
          class="sidebar-menu"
        >
          <sidebar-item
            v-for="(route, index) in routers"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            :level="`${index}`"
          ></sidebar-item>

          <el-menu-item class="logout">
            <a @click="logout">
              <i
                class="icon fa fa-power-off"
              ></i>
              <span>{{$t("meta.退出")}}</span>
            </a>
          </el-menu-item>
        </el-menu>
        
    </div>
</template>

<script>
import { mapGetters, useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

import SidebarItem from "./SidebarItem.vue";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["routers"]),
    
    
    activeMenu() {
      const route = useRoute();
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  setup(){
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    

    const logout = ()=>{
      store.dispatch("user/logout").then(()=>{
        router.push(`${t("baseurl")}/login`);
      });
      
    }

    return {
      logout,
    }
  }
};
</script>

<style lang="less" scoped></style>
